import React from "react";
import { Grid, Stack, Typography, Box, Divider } from "@mui/material";
import moment from "moment";
//Icons
import { BsInfoCircleFill } from "react-icons/bs";
import { MdContactMail } from "react-icons/md";
//Srcs
import "./studentinfo.scss";
import CakeImage from "../../Assets/birthday-cake.png";
import GenderImage from "../../Assets/equality.png";
import EmptyImage from "../../Assets/empty-image.png";

export default function StudentInfo({ detailsData }) {
  // console.log("detailsData", detailsData);

  return (
    <div className="student-info">
      <Box className="main-containner">
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
            <Box className="profile-container">
              <Stack
                className="profile"
                direction="row"
                justifycontent="center"
                sx={{ marginBottom: "20px" }}
              >
                <img
                  className="avater-image"
                  style={{ borderRadius: "10px" }}
                  src={
                    detailsData?.profileImg === "" ||
                    detailsData?.profileImg === undefined ||
                    detailsData?.profileImg === null
                      ? EmptyImage
                      : detailsData?.profileImg?.slice(0, 5) === "https"
                      ? detailsData?.profileImg
                      : `${process.env.React_App_VIEW_URL}${detailsData?.profileImg}`
                  }
                />
              </Stack>
              <Typography className="name-container-khmer">
                {detailsData?.lastName ? detailsData?.lastName : " "}{" "}
                {detailsData?.firstName ? detailsData?.firstName : " "}
              </Typography>
              <Typography className="name-container">
                {detailsData?.englishName ? detailsData?.englishName : ""}
              </Typography>
              <Stack
                direction="row"
                justifyContent="center"
                sx={{ marginTop: "20px" }}
              >
                <Stack direction="row" spacing={4} sx={{ width: "70%" }}>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img
                        src={GenderImage}
                        alt="Gender"
                        className="cake-img"
                      />
                    </Stack>
                    <Typography className="cake-title">
                      {detailsData?.gender ? detailsData?.gender : ""}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img src={CakeImage} alt="Gender" className="cake-img" />
                    </Stack>

                    <Typography className="cake-title">
                      {moment(detailsData?.dob).format("DD-MMM-YYYY")
                        ? moment(detailsData?.dob).format("DD-MMM-YYYY")
                        : ""}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={8} xl={9}>
            <Box className="details-container">
              <Grid container spacing={3}>
                {/* =============================== Student details =========================== */}
                <Grid item xs={6} sm={6} md={12} lg={12} xl={6}>
                  <Stack direction="row" spacing={1.5}>
                    <BsInfoCircleFill className="details-icon" />
                    <Typography className="details-title">
                      Student details
                    </Typography>
                  </Stack>
                  <Divider />
                  <Stack
                    direction="column"
                    spacing={1.5}
                    sx={{ marginTop: "20px" }}
                  >
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Student ID
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.student_id ? detailsData?.student_id : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Last name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.lastName ? detailsData?.lastName : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        First name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.firstName ? detailsData?.firstName : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        English name
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.englishName
                          ? detailsData?.englishName
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Date of birth
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.dob
                          ? moment(detailsData?.dob).format("DD-MMM-YYYY")
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Age</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.dob
                          ? moment().diff(moment(detailsData?.dob), "years")
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Gender</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.gender ? detailsData?.gender : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Nationality
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.nationality
                          ? detailsData?.nationality
                          : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Place of birth
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.village
                          ? detailsData?.village + ", "
                          : " "}
                        {detailsData?.commune
                          ? detailsData?.commune + ", "
                          : " "}
                        {detailsData?.district
                          ? detailsData?.district + ", "
                          : " "}
                        {detailsData?.province ? detailsData?.province : " "}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">
                        Permanent address
                      </Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.permanentVillage
                          ? detailsData?.permanentVillage + ", "
                          : " "}
                        {detailsData?.permanentCommune
                          ? detailsData?.permanentCommune + ", "
                          : " "}
                        {detailsData?.permanentDistrict
                          ? detailsData?.permanentDistrict + ", "
                          : " "}
                        {detailsData?.permanentProvince
                          ? detailsData?.permanentProvince + ", "
                          : " "}
                        {detailsData?.permanentCountry
                          ? detailsData?.permanentCountry
                          : " "}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
                {/* =============================== Contact details =========================== */}
                <Grid item xs={6} sm={6} md={12} lg={12} xl={6}>
                  <Stack direction="row" spacing={1.5}>
                    <MdContactMail className="details-icon" />
                    <Typography className="details-title">
                      Contact details
                    </Typography>
                  </Stack>
                  <Divider />
                  <Stack
                    direction="column"
                    spacing={1.5}
                    sx={{ marginTop: "20px" }}
                  >
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Email</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.email ? detailsData?.email : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Tel</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.tel ? detailsData?.tel : ""}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <Typography className="details-name">Facebook</Typography>
                      <Typography className="details-dot">:</Typography>
                      <Typography className="details-item">
                        {detailsData?.facebook ? detailsData?.facebook : ""}
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
